import { render, staticRenderFns } from "./ModalTermsOfUse.vue?vue&type=template&id=2fa7940e&scoped=true&lang=pug"
import script from "./ModalTermsOfUse.vue?vue&type=script&lang=js"
export * from "./ModalTermsOfUse.vue?vue&type=script&lang=js"
import style0 from "./ModalTermsOfUse.vue?vue&type=style&index=0&id=2fa7940e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa7940e",
  null
  
)

export default component.exports